import { useState } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { createSingleChoice } from '@flipster/react/design-system/chip';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import TokenInfo from './TokenInfo';
import TradingParameter from './trading-parameter';

type InfoSubTab = 'info' | 'tradingParameter';
const Choice = createSingleChoice<InfoSubTab>();

const InfoPanel = () => {
  const [subTab, setSubTab] = useState<InfoSubTab>('info');

  return (
    <div
      className={css(
        vstack.raw({
          gap: 16,
          alignItems: 'stretch',
          h: { tablet: '100%' },
        }),
      )}
    >
      <Choice value={subTab} onChange={setSubTab} css={{ px: 16, pt: 16 }}>
        <Choice.Chip value='info' label={<FormattedMessage id='Autogen_common.r251126.s_Info' />} />
        <Choice.Chip value='tradingParameter' label={<FormattedMessage id='Trade.r260702.Trading_parameter' />} />
      </Choice>
      <div
        className={css({ flex: { tablet: 1 }, minH: { tablet: 0 }, display: { tablet: 'flex' }, flexDir: 'column' })}
      >
        {subTab === 'info' ? <TokenInfo /> : <TradingParameter />}
      </div>
    </div>
  );
};

export default InfoPanel;
